import React, { Component } from 'react'
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";

export function CustomTable (props:any){
  return(
      <Table {...props}>
        {props.children}
      </Table>
  )
}

export class CustomTableBody extends Component {
  render() {
    return(
      <TableBody {...this.props}>
        {this.props.children}
      </TableBody>
    );
  }
}

export function CustomTableCell(props) {
    return(
      <TableCell {...props}>
        {props.children}
      </TableCell>
    );
}

export function CustomTableContainer (props:any){
  return(
      <TableContainer {...props}>
        {props.children}
      </TableContainer>
  )
}

export class CustomTableHead extends Component {
  render() {
    return(
      <TableHead {...this.props}>
        {this.props.children}
      </TableHead>
    );
  }
}

export function CustomTableRow(props:any){
  return(
    <TableRow {...props}>
      {props.children}
    </TableRow>
  );
}

export function CustomTableFooter(props:any) {
  return (
    <TableFooter {...props}>
      {props.children}
    </TableFooter>
  )
}

export function CustomTablePagination(props:any) {
  return (
    <TablePagination {...props}>
        {props.children}
      </TablePagination>
  )
}


